import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import useI18n from '~Translations';

const DividerContainer = styled(Box)`
  width: 100%;
  margin: 16px 0;
`;

const DividerLine = styled.hr`
  flex: 1;
  border: none;
  border-top: 1px solid var(--colorBlueGray1000);
  margin: 0 10px;
`;

const DividerText = styled.p`
  margin: 0;
  white-space: nowrap;
  color: #aeb9c8;
`;

interface Props {
  /* The venue's configured `lateAfterMinutesInKDS` threshold, rendered in the label */
  lateAfterMinutes: number;
}

/* Used to divide regular orders vs. pre-orders that are due later than the configured threshold */
const DueLaterDivider: FC<Props> = ({ lateAfterMinutes }) => {
  const { i18n } = useI18n();

  return (
    <DividerContainer display="flex" alignItems="center" padding="medium">
      <DividerLine />
      <DividerText>{i18n('KDS.LaterThanXMinutes', lateAfterMinutes)}</DividerText>
      <DividerLine />
    </DividerContainer>
  );
};

export default DueLaterDivider;
